import { __awaiter } from "tslib";
import { LoadedState, ReadyState, waitFor } from "../shared/index.js";
const state = {
    loadedState: LoadedState.NOT_LOADED,
    readyState: ReadyState.NOT_READY,
};
let onReadyResolver;
const onReadyPromise = new Promise((resolve) => {
    onReadyResolver = resolve;
});
const waitForReadyOrTimeout = () => Promise.race([waitFor(2000), onReadyPromise]);
const onReady = () => {
    state.readyState = ReadyState.READY;
    onReadyResolver();
};
const initTracker = (_, retryLoading) => {
    const win = window;
    win.dataLayer = win.dataLayer || [];
    waitForReadyOrTimeout().then(() => __awaiter(void 0, void 0, void 0, function* () {
        if (state.loadedState === LoadedState.FAILED_TO_LOAD_IN_BROWSER) {
            retryLoading();
        }
    }));
};
export { state as trackerState, initTracker, onReady as onTrackerReady };
//# sourceMappingURL=tracker.service.js.map